import { MediaItemFile } from './__MediaLibrary'
import { UUID } from '../types'
import { columnDefinition, tableHidden } from '../../utils/decorators'
import { Strings } from '../../utils/strings'

export class Image extends MediaItemFile {
	public static title = 'Image'
	@tableHidden
	public alt: string
	public content_type: UUID

	@columnDefinition({
		label: 'Available for trial'
	})
	public public_from?: Date

	@columnDefinition({
		label: 'Paper Number'
	})
	public paper_number: string

	constructor(item: any = {}) {
		super(item)

		this.alt = Strings.default(item.alt)
		this.content_type = Strings.default(item.content_type)
		this.paper_number = Strings.default(item.paper_number)

		if (item.public_from) {
			this.public_from = new Date(item.public_from)
		}
	}
}
